<template>
  <b-row>
    <b-col md="12">
        <b-alert v-for="(errors, id) in response.errors" :key="id" :show="dismissCountDown"
                  dismissible
                  :variant="response.success== true ? 'success':'danger'"
                  @dismissed="dismissCountdown=0"
                  @dismiss-count-down="countDownChanged">
            <p v-if="response.errors" style="font-size:13px;margin-bottom: 0;"><b>{{ id }}</b> : <span v-for="(error, index) in errors" :key="index"><br>{{ error }}</span></p>
           <strong v-if="!response.errors">{{response.message}}</strong>
        </b-alert>
        <b-alert v-if="!response.errors" :show="dismissCountDown"
                  dismissible
                  :variant="response.success== true ? 'success':'danger'"
                  @dismissed="dismissCountdown=0"
                  @dismiss-count-down="countDownChanged">
           <strong v-if="!response.errors">{{response.message}}</strong>
        </b-alert>
        <b-card>
          <div slot="header">
            Création des guichets de l'agence <strong>{{agency.nom_agence}}</strong>  
          </div>
          <b-row class="form-group">
            <b-col md="6">
              <label for="device">Nom</label>
              <b-form-input type="text" v-model="atm.nom" placeholder="Nom du guichet"></b-form-input>
            </b-col>
            <!--<b-col md="6" v-if="display_agency">
              <label for="entite_id">Agences</label>
              <b-form-select id="agence_id" :plain="true" :options="options" v-model="atm.agence_id">
              </b-form-select>
            </b-col> -->
            <b-col md="6" v-if="display_agency">
              <label for="agence_id">Agence *</label>
                <el-select style="display:block;"
                  v-model="atm.agence_id" id="agence_id"
                  loading-text="Chargement en cours"
                  no-match-text="Agence non trouvée"
                  no-data-text="Aucune données trouvées"
                  size="small"
                  filterable
                  remote
                  reserve-keyword
                  placeholder="Rechercher le nom de votre agence"
                  :remote-method="remoteAgencies"
                  :loading="loading">
                  <el-option
                    v-for="item in options4"
                    :key="item.value"
                    :label="item.text"
                    :value="item.value">
                  </el-option>
                </el-select>
            </b-col>
          </b-row>
          <div slot="footer">
            <span v-if="can('guichet-create')"><b-button type="submit" size="sm" variant="primary" @click.prevent="post()"><i class="fa fa-dot-circle-o"></i> Valider</b-button></span>
            <b-button type="reset"  @click="goBack" size="sm" variant="danger"><i class="fa fa-ban"></i> Annuler </b-button>
          </div>
        </b-card>    
    </b-col>
  </b-row>
</template>

<script>

export default {
  name: 'tables',
  data(){
    return {
      dismissSecs: 10,
      dismissCountDown: 0,
      showDismissibleAlert: false,
      response:{},
      options : [],
      display_agency :true,
      atm:{
            agence_id: '',
            nom: ''
      },
      agencies:[],
      agency:{},
      serverParams: {
        page:1,
        current_page: 1,
        paginate: 10
      },
      options4: [],
      value9: [],
      list: [],
      loading: false,
      states: []
    }
  },
  methods:{
    goBack() {
      this.$router.go(-1)
    },
    countDownChanged (dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert () {
      this.dismissCountDown = this.dismissSecs
    },
    async post(){     
        this.response = await this.$store.dispatch('atm/post_guichets',this.atm)
        this.showAlert()
        this.reset()
    },
    async get_all_agencies(){
          
          //this.agencies =  store.getters['agency/rows'];
          if(this.$route.params.agence_id === null || this.$route.params.agence_id === 'null'){
              if (this.userConnected.role.toUpperCase()!='CHEF AGENCE'){
                await this.$store.dispatch('agency/get_all_agenciesOwn',this.serverParams).then(()=>{
                  return this.agencies =  store.getters['agency/rows'];
                })
                  this.display_agency = true
                  this.agencies.forEach((element)=>{
                    this.options.push({
                      value:element.id,
                      text:element.nom_agence.toUpperCase(),
                    })
                })
              }else{this.display_agency = false}
          }else{
              await this.$store.dispatch('agency/show_agency',this.$route.params.agence_id).then((res)=>{
                  this.agency = res
              })
              this.display_agency = false
              this.atm.agence_id = this.$route.params.agence_id
              this.options.push({
                value:this.$route.params.agence_id,
                text:this.$route.params.agence_id
              })
          }
      console.log("option ",this.options)
    },
    async get_all_users(){
      this.userConnected = await store.getters['auth/get_user']
      if(this.userConnected.role.toUpperCase()=="CHEF AGENCE"){
        let userInfo = await store.getters['auth/userInfo']
      console.log('this.userconnected ',userInfo)

          this.atm.agence_id = userInfo.agence_id
      }
    },
    remoteAgencies(query) {
        
        if (query !== '') {
          this.loading = true;
          setTimeout(() => {
            this.loading = false;
            this.options4 = this.options.filter(item => {
              return item.text.toLowerCase()
                .indexOf(query.toLowerCase()) > -1;
            });
          }, 200);
        } else {
          this.options4 = [];
        }
    },
    reset(){
      this.atm.nom= '',
      this.atm.solde= ''
    },
    can(perm){
        return store.getters['auth/can'](perm)
    }
  },
  async mounted(){
    await this.get_all_users()
    this.get_all_agencies()
  }
}
</script>
